module.exports = __webpack_public_path__ + "static/media/grace-hands.ed97cccb.png";